import { Network } from '@capacitor/network';
import { isNativeAndroid } from '@/lib/nativeRuntime';

type Listener = () => void;

const listeners = new Set<Listener>();
let online = typeof navigator === 'undefined' ? true : navigator.onLine;
let initialized = false;

function updateOnline(next: boolean): void {
  if (online === next) return;
  online = next;
  for (const listener of listeners) listener();
}

function initialize(): void {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;

  if (isNativeAndroid()) {
    void Network.getStatus().then((status) => updateOnline(status.connected)).catch(() => updateOnline(false));
    void Network.addListener('networkStatusChange', (status) => updateOnline(status.connected));
    return;
  }

  window.addEventListener('online', () => updateOnline(true));
  window.addEventListener('offline', () => updateOnline(false));
}

export function getOnlineStatus(): boolean {
  initialize();
  return online;
}

export function subscribeOnlineStatus(listener: Listener): () => void {
  initialize();
  listeners.add(listener);
  return () => listeners.delete(listener);
}
